<template>
  <div>
    <template v-if="type==8">
      <Card>
        <p slot="title">{{this.$t("Bill.ebilling.awsBill")}}</p>
        <ul>
          <li v-for="(item,index) in menuList" :key="index">
            <h4 @click="clickContent(item.type)" style="cursor: pointer;" :class="{active : active == item.type}" >{{item.name}}</h4>
          </li>
        </ul>
      </Card>
    </template>
    <iframe src="" id="mobsf" scrolling="no" frameborder="0" style="width:100%;height:100%;"></iframe>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        type: 8,
        active:'',
        menuList: [
          {
            type: 0,
            name: this.$t("Bill.ebilling.dashboard")
          },
          {
            type: 1,
            name: this.$t("Bill.ebilling.account")
          },
          {
            type: 2,
            name: this.$t("Bill.ebilling.tag")
          },
          {
            type: 3,
            name: this.$t("Bill.ebilling.service")
          },
          {
            type: 4,
            name: this.$t("Bill.ebilling.LicenseRI")
          },
          {
            type: 5,
            name: this.$t("Bill.ebilling.NolicenceRI")
          },
          {
            type: 6,
            name: this.$t("Bill.ebilling.region")
          },
          {
            type: 7,
            name: this.$t("Bill.ebilling.custom")
          },
          {
            type: 8,
            name: this.$t("Bill.ebilling.bill")
          }]
      }
    },
    mounted() {
      /**
       * iframe-宽高自适应显示
       */
      function changeMobsfIframe() {
        const mobsf = document.getElementById('mobsf');
        const deviceWidth = document.body.clientWidth;
        const deviceHeight = document.body.clientHeight;
        // mobsf.style.width = (Number(deviceWidth) - 240) + 'px'; //数字是页面布局宽度差值
        mobsf.style.height = (Number(deviceHeight) - 64) + 'px'; //数字是页面布局高度差
      }

      var mobsf = document.getElementById("mobsf");
      var language = localStorage.getItem('locale');
      if (language == 'zh') {
        mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=DashBoard.db";
      } else if (language == 'en') {
        mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=DashBoard_en.db";
      }

      changeMobsfIframe()

      window.onresize = function () {
        changeMobsfIframe()
      }
    },
    methods: {
      clickContent: function (item) {
        var mobsf = document.getElementById("mobsf");
        var language = localStorage.getItem('locale');
        this.active = item;
        if (language == 'zh') {
          if (item == 0) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=DashBoard.db";
          } else if (item == 1) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=AccountPage.db";
          } else if (item == 2) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=TagPage.db";
          } else if (item == 3) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=ServicePage.db";
          } else if (item == 4) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=RIPage.db";
          } else if (item == 5) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=LinuxRI.db";
          } else if (item == 6) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=RegionPage.db";
          } else if (item == 7) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=CustomeriseQuery.db";
          } else if (item == 8) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=BillingPage.db";
          }
        } else if (language == 'en') {
          if (item == 0) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=DashBoard_en.db";
          } else if (item == 1) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=AccountPage_en.db";
          } else if (item == 2) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=TagPage_en.db";
          } else if (item == 3) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=ServicePage_en.db";
          } else if (item == 4) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=RIPage_en.db";
          } else if (item == 5) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=LinuxRI_en.db";
          } else if (item == 6) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=RegionPage_en.db";
          } else if (item == 7) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=CustomeriseQuery_en.db";
          } else if (item == 8) {
            mobsf.src = "https://e-billing.sh-silverlining.com/bi/View?proc=1&action=viewer&hback=true&db=BillingPage_en.db";
          }
        }
        return false;
      }
    }
  }
</script>

<style scoped>
  .case-title {
    width: 100%;
    font-size: 13px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px 0px 8px 4px;
    font-weight: 600;
  }

  .case-title > div:nth-child(1) {
    float: left;
  }
  ul{
    overflow: hidden;
  }

  ul li {
    margin-bottom: 10px;
    float:left;
    width:100px;
  }
  ul li:nth-child(5){
    width:130px;
  }
  ul li:nth-child(6){
    width:140px;
  }
  ul li:nth-child(8){
    width:132px;
  }
  .active {
   color: #2e8cf0;
 }
</style>



// WEBPACK FOOTER //
// src/components/ebilling/ebilling/AWS.vue